module.exports = __webpack_public_path__ + "img/login2.34599c02.png";